export enum TipoTemplateEnum {
  MARKETING = 'Marketing',
  UTILITY = 'Utilidade',
  AUTHENTICATION = 'Autenticação',
}
